import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  TextField,
  MenuItem,
  Button,
} from "@mui/material";
import React, { useState, useContext, useEffect } from "react";
import PsContext from "../../context";
import {
  _ADD_CATEGORY,
  _ADD_TASK,
  _EDIT_CATEGORY,
  _EDIT_TASK,
  _LIST_STAFFS,
  _LIST_TASK_CATEGORIES,
  _LIST_TASK_PRIORITIES,
} from "../../models/task";
import { Dialog, List, SwipeAction, Toast } from "antd-mobile";

const AddCategory = (props) => {
  const context = useContext(PsContext);
  const [categoryName, setCategoryName] = useState(null);
  const [categoryDesc, setCategoryDesc] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = () => {
    // Validate all fields
    if (!categoryName || !categoryDesc) {
      setErrorMessage("Please fill in all required fields.");
      return;
    }

    // Create a task object
    const catData = {
      category_name: categoryName,
      category_description: categoryDesc,
    };
    _ADD_CATEGORY(catData)
      .then((res) => {
        Toast.show({
          icon: "success",
          content: res.message ? res.message : "Category successfully Added!",
        });
        if (props.onSuccess) props.onSuccess();
      })
      .catch((error) => {
        console.error("Error Adding Category:", error);
        Toast.show({
          icon: "fail",
          content: "Error Adding Category. Please try again.",
        });
        if (props.onSuccess) props.onSuccess();
      });
  };

  return (
    <Card>
      <CardContent>
        {errorMessage && <div style={{ color: "red" }}>{errorMessage}</div>}
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Category Name"
              value={categoryName}
              onChange={(e) => setCategoryName(e.target.value)}
              required
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Category Description"
              value={categoryDesc}
              onChange={(e) => setCategoryDesc(e.target.value)}
              multiline
              rows={4}
              required
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} mt={2} alignItems="flex-end">
          <Grid item xs={12} md={3}>
            <Button variant="contained" fullWidth onClick={handleSubmit}>
              Save
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default AddCategory;
